import { ScoreBand } from '@app/src/pages/SustainabilityProfile/profileLogic'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { SCORE_LEGEND_COLOR } from './profileColors'

const BANDS: { band: ScoreBand; min: number; max: number }[] = [
  { band: ScoreBand.VeryLow, min: 0, max: 20 },
  { band: ScoreBand.Low, min: 20, max: 40 },
  { band: ScoreBand.Medium, min: 40, max: 60 },
  { band: ScoreBand.High, min: 60, max: 80 },
  { band: ScoreBand.VeryHigh, min: 80, max: 100 },
]

const SWATCH_SIZE = 12

const LegendItem: React.FC<{ swatch: React.ReactNode; label: string }> = ({ swatch, label }) => (
  <Stack direction="row" spacing={1} alignItems="center">
    {swatch}
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Stack>
)

interface ScoreLegendProps {
  action?: React.ReactNode
}

const ScoreLegend: React.FC<ScoreLegendProps> = ({ action }) => {
  const { formatMessage } = useIntl()

  return (
    <Stack direction="row" alignItems="center" spacing={3}>
      <Stack direction="row" flexWrap="wrap" alignItems="center" rowGap={1} columnGap={3} flex={1}>
        {BANDS.map(({ band, min, max }) => (
          <LegendItem
            key={band}
            label={formatMessage({ id: 'sustainabilityProfile.topics.legend.range' }, { min, max })}
            swatch={
              <Box width={SWATCH_SIZE} height={SWATCH_SIZE} borderRadius="50%" bgcolor={SCORE_LEGEND_COLOR[band]} />
            }
          />
        ))}
        <LegendItem
          label={formatMessage({ id: 'sustainabilityProfile.topics.legend.peerMean' })}
          swatch={
            <Box
              width={SWATCH_SIZE}
              height={SWATCH_SIZE}
              borderRadius="50%"
              bgcolor="background.paper"
              sx={{ border: 2, borderColor: 'grey.900' }}
            />
          }
        />
      </Stack>
      {action}
    </Stack>
  )
}

export default ScoreLegend
